module.exports = __webpack_public_path__ + "img/stars.cb76f16f.png";